<template>
  <section v-if="details">


    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <b-nav-item
          href="#"
          @click="copyUrlClipBoard"
          v-b-tooltip.hover
          :title="$t('TEMPLATE.COPY_LINK')"
        >
          <i class="fal fa-external-link" />
          <span>{{ $t('TEMPLATE.COPY_LINK') }}</span>
        </b-nav-item>        
        <b-nav-item :href="downloadUrl" v-b-tooltip.hover :title="$t('TEMPLATE.DOWNLOAD_DOCUMENT')">
          <i class="fal fa-download" />
          <span>{{ $t('TEMPLATE.DOWNLOAD_DOCUMENT') }}</span>
        </b-nav-item>
        <b-nav-item
          href="#"
          @click="showModalVersions"
          v-b-tooltip.hover
          :title="$t('TEMPLATE.HISTORY')"
        >
          <i class="fal fa-history" />
          <span>{{ $t('TEMPLATE.HISTORY') }}</span>
        </b-nav-item>
        <b-nav-item href="#" @click="showModalHash" v-b-tooltip.hover :title="$t('TEMPLATE.HASH')">
          <i class="fal fa-hashtag" />
          <span>{{ $t('TEMPLATE.HASH') }}</span>
        </b-nav-item>
         <b-nav-item href="#" @click="showModalQR" v-b-tooltip.hover :title="$t('TEMPLATE.QRCODE')">
          <i class="fal fa-qrcode" />
          <span>{{ $t('TEMPLATE.QRCODE') }}</span>
        </b-nav-item>
      </b-nav>

      <b-nav class="ml-auto right" v-if="loggedIn">
        <add-version
          v-if="details.document.teamId ===  user.team.id"
          @updatedDocumentVersion="updatedDocumentVersion"
          :item="details"
          :key="details.document.id"
        >
          <b-nav-item href="#" v-b-tooltip.hover :title="$t('TEMPLATE.ADD_NEW_VERSION')">
            <i class="fal fa-plus-circle" />
            <span>{{$t('TEMPLATE.ADD_NEW_VERSION')}}</span>
          </b-nav-item>
        </add-version>
        
        <initiate-document
          v-if="details.document.teamId ===  user.team.id"
          :item="details"
        >
          <b-nav-item href="#" v-b-tooltip.hover :title="$t('TEMPLATE.INITIATE_DOCUMENT')">
            <i class="fal fa-play-circle" />
            <span>{{$t('TEMPLATE.INITIATE_DOCUMENT')}}</span>
          </b-nav-item>
        </initiate-document>

      </b-nav>
    </b-navbar>


    <div class="container-fluid mt-2">
      <h3>
        <i class="fal fa-file-alt" />
        {{ details.document.name }} {{ details.documentVersion.version }}
      </h3>

        <b-alert show class="text-center" v-if="newVersions === 0">{{ $t('TEMPLATE.THIS_IS_THE_LATEST_DOCUMENT') }}</b-alert>
          <b-alert variant="danger" show v-if="newVersions !== 0" class="mb-4 text-center">
            {{ $t('TEMPLATE.THIS_IS_NOT_THE_LATEST_DOCUMENT', {
            versions: newVersions }) }}
            <hr />
            <div class="text-center">
              <router-link
                :to="{ name: 'Template', params: { dclIdentity: details.document.publishedDclIdentity }}"
              >
                <i class="fal fa-file-alt" />
                {{$t('TEMPLATE.GOTO_LATEST_VERSION')}}
              </router-link>
            </div>
          </b-alert>
    </div>

    


    <div class="container-fluid mt-2">       

          
          <h5>{{$t('TEMPLATE.INFORMATION')}}</h5>
          <b-card>
            <dl>
              <dt>{{ $t('TEMPLATE.NAME') }}</dt>
              <dd>{{ details.document.name }}</dd>
              <dt>{{ $t('TEMPLATE.ID') }}</dt>
              <dd>{{ details.documentVersion.dclIdentity }}</dd>
              <dt>{{ $t('TEMPLATE.PUBLISHER') }}</dt>
              <dd>{{ details.team }}</dd>
              <dt>{{ $t('TEMPLATE.VERSION') }}</dt>
              <dd>{{ details.documentVersion.version }}</dd>
              <dt>{{ $t('TEMPLATE.REPLACED') }}</dt>
              <dd>{{ replacedBy }}</dd>
              <dt>{{ $t('TEMPLATE.PUBLISHED') }}</dt>
              <dd>{{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</dd>
            </dl>
          </b-card>
          
    </div>

    <b-modal v-model="modalVersions" size="xl" centered no-fade hide-header>
      <div slot="modal-header" class="w-100">{{$t('TEMPLATE.HISTORY_MODAL_TITLE')}}</div>
      <div class="mt-2">
        <b-table
          hover
          :items="historyItems"
          :fields="historyFields"
          selectable
          select-mode="multi"
          @row-selected="setVersion"
        >
          <template v-slot:cell(publishedDate)="data">
              {{ $moment(data.value) | moment("YYYY-MM-DD HH:mm") }}
          </template>
        </b-table>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>

    <b-modal v-model="modalQR" size="xl" centered no-fade hide-header>
      <div slot="modal-header" class="w-100">{{$t('TEMPLATE.HISTORY_MODAL_TITLE')}}</div>
      <div class="mt-2 p-4 text-center">

        <img
              v-bind:src="'data:image/png;base64,'+image"
              style="height: 300px; border-radius: 5px; border: 1px solid #000;"
            />
            
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>

    <b-modal v-model="modalHash" hide-header size="lg" centered no-fade>
      <div class="p-4">

        <dl>
          <dt>{{ $t('TEMPLATE.HASH_METHOD') }}</dt>
          <dd>{{details.documentVersion.hashMethod}}</dd>
          <dt>{{ $t('TEMPLATE.HASH') }}</dt>
          <dd>{{hash}}</dd>
        </dl>
        
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>
  </section>
</template>
<script>
import AddVersion from "@/components/Templates/AddVersion";
import InitiateDocument from "@/components/Templates/InitiateDocument";
export default {
  props: ['dclIdentity'],
  components: {
    AddVersion,
    InitiateDocument
  },
  data() {
    return {
      selected: 0,
      showDetails: false,
      modalVersions: false,
      modalQR: false,
      modalHash: false,
      newVersions: 0,
      details: null,
      publishedDetails: {},
      size: 250,
      image: "",
      bgColor: "#fff",
      fgColor: "#000",
      logo: "/img/qr-logo.png",
      historyItems: [],
      historyPage: 0,
      historyLimit: 25,
      historyCount: 0,
      historyFields: [
        {
          key: "version",
          label: this.$t("TEMPLATE.TABLE.VERSION"),
          sortable: false
        },
        {
          key: "publishedDate",
          label: this.$t("TEMPLATE.TABLE.PUBLISHED_DATE"),
          sortable: false
        },
        {
          key: "dclIdentity",
          label: this.$t("TEMPLATE.TABLE.DCLIDENTITY"),
          sortable: false
        }
      ],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    updatedDocumentVersion: function(documentInformation) {
      this.details.documentVersion = documentInformation;
    },
    showModalHash: function() {
      this.modalHash = true;
    },
    showModalQR: function() {
      this.modalQR = true;
    },
    showModalVersions: function() {
      this.getHistory();
      this.modalVersions = true;
    },
    hideModals: function() {
      this.modalVersions = false;
      this.modalQR = false;
      this.modalHash = false;
    },
    copyUrlClipBoard() {
      let self = this;
      this.$copyText(this.documentUrl).then(
        function() {
          self.$noty.info(self.$t("TEMPLATE.SUCCESS.COPIED_URL"));
        },
        function() {
          self.$noty.error(self.$t("TEMPLATE.ERROR.COULD_NOT_COPY_LINK"));
        }
      );
    },
    copyHash() {
      let self = this;
      this.$copyText(this.documentUrl).then(
        function() {
          self.$noty.info(self.$t("LEDGER.DETAILS.COPIED_HASH"));
        },
        function() {
          self.$noty.error(self.$t("LEDGER.ERROR.COULD_NOT_COPY_HASH"));
        }
      );
    },
    setVersion: function(item) {
      this.hideModals();
      this.$router.push("/template/" + item[0].dclIdentity);
    },
    getHistory: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/templates/history", {
          page: this.historyPage,
          limit: this.historyLimit,
          dclIdentity: this.details.document.dclIdentity
        })
        .then(response => {
          self.historyItems = response.data.items;
          self.historyCount = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    getDocument: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/template/information", {
          dclIdentity: this.dclIdentity
        })
        .then(response => {
          self.newVersions = response.data.newVersions;
          self.image = response.data.image;
          self.details = response.data.item;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  computed: {
    hash() {
      return this.details.documentVersion.hash;
    },
    documentUrl() {
      return (
        process.env.VUE_APP_FRONTEND +
        "/template/" +
        this.details.documentVersion.dclIdentity
      );
    },    
    downloadUrl() {
      return (
        process.env.VUE_APP_BACKEND +
        "/template/download/" +
        this.details.documentVersion.dclIdentity + ".xml"
      );
    },
    loggedIn() {
      return this.$store.state.auth.user;
    },
    replacedBy() {
      if (this.details.documentVersion.replacedByDclIdentity === "") {
        return this.$t("TEMPLATE.THIS_IS_THE_FIRST_VERSION");
      }
      if (
        this.details.documentVersion.dclIdentity ===
        this.details.documentVersion.replacedByDclIdentity
      ) {
        return this.$t("TEMPLATE.THIS_IS_THE_LATEST_VERSION");
      }
      return this.details.documentVersion.replacedByDclIdentity;
    }
  },
  watch: {
    dclIdentity: function(){
       this.getDocument();
    }
  },
  mounted() {
    this.getDocument();
  }
};
</script>
<style>
</style>